import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
import chart from './chart';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.vNodeButtonEchart, this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])])]), h(chart, {
      "directives": [{
        name: "show",
        value: this.chart_show
      }],
      "model": {
        value: _this.chart_show,
        callback: function callback($$v) {
          _this.chart_show = $$v;
        }
      }
    }), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      chart_show: false,
      api: {
        index: 'RECORD_AB_USED_ALL',
        delete: 'RECORD_AB_USED_DELETE',
        sync: 'RECORD_AB_USED_SYNC'
      },
      permission: {
        query: '',
        add: '',
        edit: '',
        detail: '',
        remove: '',
        sync_sms: ''
      },
      userInfo: {}
    };
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$store.dispatch('d2admin/db/get', {
                dbName: 'sys',
                path: 'user.info',
                defaultValue: {},
                user: true
              }, {
                root: true
              });

            case 2:
              _this2.userInfo = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      var columns = [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '80px'
      }, {
        prop: 'market_id',
        label: this.$t('market_mobile'),
        minWidth: '120px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "table_market_id",
              "value": row.market_id,
              "custom": true
            }
          });
        }
      }, {
        prop: 'device_number',
        label: this.$t('device_number'),
        minWidth: '120px'
      }, // { prop: 'device_uid', label: 'device_uid', minWidth: '120px' },
      {
        prop: 'device_name',
        label: this.$t('device_name'),
        width: '120px'
      }, {
        prop: 'device_address',
        label: this.$t('device_address'),
        width: '150px'
      }, // { prop: 'box_uid', label: 'box_uid', width: '200px' },
      {
        prop: 'box_aspect_type',
        label: this.$t('size'),
        minWidth: '80px',
        render: function render(_ref2) {
          var row = _ref2.row;
          return row.market_id == "17" || row.market_id == "12" ? h("d2-dict", {
            "attrs": {
              "name": "box_aspect_type_two",
              "value": row.box_aspect_type
            }
          }) : h("d2-dict", {
            "attrs": {
              "name": "box_aspect_type",
              "value": row.box_aspect_type
            }
          });
        }
      }, {
        prop: 'box_name',
        label: this.$t('box_name'),
        minWidth: '100px'
      }, {
        prop: 'save_user_mobile',
        label: this.$t('save mobile'),
        width: '120px'
      }, {
        prop: 'get_user_mobile',
        label: this.$t('get mobile'),
        width: '120px'
      }, {
        prop: 'used_status',
        label: this.$t('used_status'),
        width: '140px',
        render: function render(_ref3) {
          var row = _ref3.row;
          return h("d2-dict", {
            "attrs": {
              "name": "used_status",
              "value": row.used_status
            }
          });
        }
      }, {
        prop: 'send_msg_status',
        label: this.$t('sms status'),
        width: '100px',
        render: function render(_ref4) {
          var row = _ref4.row;
          return h("d2-dict", {
            "attrs": {
              "name": "send_msg_status",
              "value": row.send_msg_status
            }
          });
        }
      }, {
        prop: 'get_time',
        label: this.$t('get_time'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.get_time, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'save_time',
        label: this.$t('save_time'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.save_time, 'YYYY/M/D HH:mm:ss');
        }
      }, // { prop: 'save_trade_no', label: 'save_trade_no', width: '120px' },
      {
        prop: 'save_pay_money',
        label: this.$t('save pay money'),
        width: '100px',
        formatter: function formatter(row) {
          return row.save_pay_money ? row.save_pay_money / 100 : '0';
        }
      }, // { prop: 'get_trade_no', label: 'get_trade_no', width: '160px' },
      {
        prop: 'get_pay_money',
        label: this.$t('get pay money'),
        width: '100px',
        formatter: function formatter(row) {
          return row.get_pay_money ? row.get_pay_money / 100 : '0';
        }
      }, {
        prop: 'order_number',
        label: this.$t('order_number'),
        width: '160px'
      }, {
        prop: 'pick_code',
        label: this.$t('pick_code'),
        width: '160px'
      }, {
        prop: 'save_type',
        label: this.$t('save_type'),
        width: '160px',
        render: function render(_ref5) {
          var row = _ref5.row;
          return h("d2-dict", {
            "attrs": {
              "name": "save_type",
              "value": row.save_type
            }
          });
        }
      }, {
        prop: 'get_type',
        label: this.$t('get_type'),
        width: '160px',
        render: function render(_ref6) {
          var row = _ref6.row;
          return h("d2-dict", {
            "attrs": {
              "name": "express_get_type",
              "value": row.get_type
            }
          });
        }
      }, // { prop: 'send_sms_key', label: 'send_sms_key', width: '120px' },
      {
        prop: 'uptime',
        label: this.$t('uptime'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'ctime',
        label: this.$t('ctime'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });

      if (this.userInfo.market_id == '17' || this.userInfo.market_id == '12') {
        columns.splice(8, 0, {
          prop: 'get_user_uid',
          label: this.$t('姓名'),
          width: '160px'
        });
      }

      return columns;
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this3 = this;

      return function (_ref7) {
        var row = _ref7.row;
        return _toConsumableArray(_this3.p('sync_sms', [{
          icon: 'el-icon-upload2',
          label: _this3.$t('resend sms'),
          type: 'danger',
          confirm: _this3.$t('confirm_sync_sms'),
          action: function action() {
            return _this3.sync({
              'id': row.id,
              'optype': 'resendSms'
            });
          }
        }], []));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this4 = this;

      var h = this.$createElement;
      return [{
        prop: 'market_mobile',
        label: this.$t('market_mobile'),
        default: utils.cookies.get('phone'),
        show: false,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this4.search.form.model.market_mobile,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "market_mobile", $$v);
              }
            }
          });
        } // render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:140px;" custom clearable/>

      }, {
        prop: 'device_number',
        label: this.$t('device_number'),
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:140px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this4.search.form.model.device_number,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "device_number", $$v);
              }
            }
          });
        }
      }, {
        prop: 'pick_code',
        label: this.$t('pick_code'),
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:100px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this4.search.form.model.pick_code,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "pick_code", $$v);
              }
            }
          });
        }
      }, {
        prop: 'save_user_mobile',
        label: this.$t('save mobile'),
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this4.search.form.model.save_user_mobile,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "save_user_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'get_user_mobile',
        label: this.$t('get mobile'),
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this4.search.form.model.get_user_mobile,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "get_user_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'used_status',
        label: this.$t('used_status'),
        default: '',
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "used_status",
              "custom": true,
              "clearable": true
            },
            "style": "width:170px;",
            "model": {
              value: _this4.search.form.model.used_status,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "used_status", $$v);
              }
            }
          });
        }
      }, {
        prop: 'order_number',
        label: this.$t('order_number'),
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:180px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this4.search.form.model.order_number,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "order_number", $$v);
              }
            }
          });
        }
      }, {
        prop: 'save_trade_no',
        label: this.$t('save_trade_no'),
        default: this.save_trade_no,
        show: false,
        render: function render() {
          return h("el-input", {
            "style": "width:180px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this4.search.form.model.save_trade_no,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "save_trade_no", $$v);
              }
            }
          });
        }
      }, {
        prop: 'start_time',
        label: this.$t('start_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this4.search.form.model.start_time,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this4.search.form.model.end_time,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    },
    save_trade_no: function save_trade_no() {
      return this.$route.query.order_no;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    goOrderBoxData: function goOrderBoxData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-order-box';
      });
      this.$router.push({
        name: 'management-wash-order-box',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderClothData: function goOrderClothData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-order-cloth';
      });
      this.$router.push({
        name: 'management-wash-order-cloth',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderPayData: function goOrderPayData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-order-pay';
      });
      this.$router.push({
        name: 'management-wash-order-pay',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderPreferData: function goOrderPreferData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-order-prefer';
      });
      this.$router.push({
        name: 'management-wash-order-prefer',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderAdminRecordData: function goOrderAdminRecordData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-admin-record';
      });
      this.$router.push({
        name: 'management-wash-admin-record',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderDeviceRecordData: function goOrderDeviceRecordData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-box-switch-record';
      });
      this.$router.push({
        name: 'management-wash-box-switch-record',
        query: {
          wash_id: wash_id
        }
      });
    },
    loadDict: function loadDict() {
      this.loadDictOne({
        name: 'search_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
      this.loadDictOne({
        name: 'table_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
    }
  })
};